import React from "react";
import AntdForm, {FormProps} from "antd/lib/form";
import { withError} from '@fishx/tracker';

const useForm = AntdForm.useForm;
const Item = AntdForm.Item;
const List = AntdForm.List;
const ErrorList = AntdForm.ErrorList;
const Provider = AntdForm.Provider;
interface FCFormProps extends React.FC<FormProps> {
  useForm: typeof useForm;
  Item: typeof Item;
  List: typeof List;
  ErrorList: typeof ErrorList;
  Provider: typeof Provider;
  create: () => void;
}

export const Form: FCFormProps = (props) => {
  return <AntdForm {...props} />
}

Form.useForm = useForm;
Form.Item = Item;
Form.List = List;
Form.ErrorList = ErrorList;
Form.Provider = Provider;
Form.create = () => {};

Form.displayName = 'Form';
export default withError(Form);



// WEBPACK FOOTER //
// ./src/components/form/index.tsx